export default {
  TWO_COLUMNS: 'TWO_COLUMNS',
  THREE_COLUMNS: 'THREE_COLUMNS',
};
